import { tv } from 'tailwind-variants';

export const headingStyles = tv({
  base: 'text-secondary-two',
  variants: {
    design: {
      external: '',
    },
    size: {
      h1: 'text-2xl lg:text-4xl 2xl:text-5xl',
      h2: 'text-xl lg:text-3xl 2xl:text-4xl',
      h3: 'text-lg lg:text-2xl 2xl:text-3xl',
      h4: 'text-lg lg:text-xl 2xl:text-2xl',
      h5: 'text-base lg:text-lg 2xl:text-xl',
      h6: 'text-base lg:text-lg 2xl:text-xl',
      custom: '',
    },
    bold: {
      true: 'font-bold',
    },
    italic: {
      true: 'italic',
    },
    underline: {
      true: 'underline',
    },
  },
});
